<template>
  <div class="hello" style="background-color: #f6f6f6">
    <div class="header">
      <div @click="backJump" style="color: #fff; padding-top: 10px; margin-left: 10px">
        <span style="line-height: 30px"
          ><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span
        >
      </div>
      <div class="clear"></div>
      <img
        src="../assets/topback.png"
        style="width: 50%; height: 75%; float: right; margin-top: -10px"
        alt=""
      />
      <div>
        <h3><span>电</span>费后付费账单</h3>
      </div>
    </div>

    <div class="center" style="position: relative">
      <div class="content">
        <div class="content_top">
          <div class="bt">
            <img src="../assets/dian.png" />
            <span>电费</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px; color: #8e8e8e">识别编码信息</span>
            <span style="font-size: 15px; float: right">{{ allBody.houseHoldNumber }}</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px; color: #8e8e8e">住址信息</span>
            <span style="font-size: 15px; float: right">{{ allBody.address }}</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px; color: #8e8e8e">余额</span>
            <span style="font-size: 15px; float: right">{{ allBody.balance }}</span>
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="content_bottom">
          <div class="center_bottom">
            <div class="down">
              <p style="color: #0f72dd">缴费金额</p>
              <div class="allin">
                <van-button
                  type="info"
                  @click="backchange(1)"
                  :style="colorone"
                  style="width: 40%"
                  >100元</van-button
                >
                <van-button
                  type="info"
                  @click="backchange(2)"
                  :style="colortwo"
                  style="width: 40%"
                  >200元</van-button
                >
                <van-button
                  type="info"
                  @click="backchange(3)"
                  :style="colorthree"
                  style="width: 40%; margin-top: 30px"
                  >300元</van-button
                >
                <van-button
                  type="info"
                  @click="backchange(0)"
                  :style="colorzero"
                  style="width: 40%; margin-top: 30px"
                  >自定义金额</van-button
                >
              </div>
              <div :style="inputmonenone">
                <van-field v-model="price" type="number" label="¥" />
              </div>
            </div>
          </div>
          <van-button
            type="primary"
            @click="goJump1"
            style="
              width: 90%;
              margin: 30px auto;
              background-color: #2d86f6;
              height: 50px;
              border-radius: 10px;
              font-size: 16pt;
              letter-spacing: 1px;
            "
            block
            >立即缴费</van-button
          >

          <p style="font-size: 15px; margin-top: 20px; margin-bottom: 20px">
            <span>手续费</span>
            <span style="float: right">{{ content.taxPrice }}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 绑定用户弹窗 -->
    <van-popup v-model="showBindPopup" round :close-on-click-overlay="false">
      <div style="width: 320px; padding: 16px">
        <div style="font-weight: bold; font-size: 16px; margin-bottom: 8px">确认绑定用户</div>
        <div v-if="bindList.length === 0" style="color: #969799; font-size: 13px">未查询到该手机号的用户</div>
        <div v-else>
          <div v-for="(item, idx) in bindList" :key="idx" @click="selectedBindIndex = idx" style="background: #f7f8fa; border-radius: 8px; padding: 10px; margin-top: 8px; cursor: pointer; border: 1px solid; text-align: center" :style="{ borderColor: selectedBindIndex === idx ? '#1989fa' : '#f7f8fa' }">
            <van-cell
              title="用户名称："
              :value="item.name"
              style="margin-top: 5px"
              :title-style="{ width: '100%', textAlign: 'center' }"
              :value-style="{ width: '100%', textAlign: 'center' }"
            />
            <van-cell
              title="用户地址："
              :value="item.actName"
              style="margin-top: 5px"
              :title-style="{ width: '100%', textAlign: 'center' }"
              :value-style="{ width: '100%', textAlign: 'center' }"
            />
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 12px">
          <van-button size="small" type="default" @click="showBindPopup = false">取消</van-button>
          <van-button size="small" type="primary" :loading="binding" :disabled="bindList.length === 0 || selectedBindIndex < 0" @click="confirmBindAndPay">立即绑定</van-button>
        </div>
        <div v-if="bindQueryError" style="color: #ee0a24; font-size: 12px; margin-top: 8px">{{ bindQueryError }}</div>
      </div>
    </van-popup>

    <div class="foot">
      <div class="bot">
        <p style="color: #0f72dd">缴费服务</p>
        <div style="border-bottom: 1px solid #8e8e8e; height: 70px; margin-top: 35px">
          <img src="../assets/money.png" style="width: 50px; float: left" alt="" />
          <div style="margin-left: 60px">
            <span>缴费记录</span>
            <button
              @click="element"
              style="
                border: none;
                width: 80px;
                border-radius: 50px;
                background-color: #0f72dd;
                color: #fff;
                height: 30px;
                line-height: 30px;
                float: right;
                margin-top: 10px;
              "
            >
              进入
            </button>
            <p>可查询每笔缴费记录</p>
          </div>
        </div>
        <div>
          <img src="../assets/jil.png" style="width: 50px; float: left" alt="" />
          <div style="margin-left: 60px">
            <span>用量记录</span>
            <button
              @click="balance"
              style="
                border: none;
                width: 80px;
                border-radius: 50px;
                background-color: #0f72dd;
                color: #fff;
                height: 30px;
                line-height: 30px;
                float: right;
                margin-top: 10px;
              "
            >
              进入
            </button>
            <p>日报、周报、月报</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
  billList,
  periods,
  postpaid,
  billData,
  orderAll,
  wxPay,
} from "../common/api/elall";
import {bindHouse, phoneHouse} from "../common/api/room";
import jump from "../common/jump";

export default {
  data() {
    return {
      id: "",
      payer: "",
      text: "",
      qis: "",
      allelectric: "",
      houseHoldNumber: "",
      address: "",
      showprides: false,
      wuy: "",
      charge: "",
      status: true,
      periods: [],
      year: "2022",
      show: false,
      value1: 0,
      start: "",
      end: "",
      devId: "",
      showPicker: false,
      projectId: "",
      projectName: "",
      columns: [],
      uptime: "",
      mchNumber: "",
      payType: 1,
      all: [],
      houseHold: "",
      content: [],
      allBody: [],
      balanceAddData: "",
      colorone: {
        backgroundColor: "#2D86F6",
        height: "25pt",
        borderRadius: "5px",
      },
      colortwo: {
        backgroundColor: "#8e8e8e",
        height: "25pt",
        borderRadius: "5px",
        marginLeft: "50px",
      },
      colorthree: {
        backgroundColor: "#8e8e8e",
        height: "25pt",
        borderRadius: "5px",
      },
      colorzero: {
        backgroundColor: "#8e8e8e",
        height: "25pt",
        borderRadius: "5px",
        marginLeft: "50px",
      },
      inputmonenone: {
        display: "none",
        marginTop: "30px",
        height: "26px",
        borderBottom: "1px solid #dee1e5",
      },
      price: 100,
      // 绑定弹窗相关
      showBindPopup: false,
      bindList: [],
      selectedBindIndex: -1,
      binding: false,
      bindQueryError: "",
    };
  },
  mounted() {
    console.log(this.$route.query)
    this.houseHold = this.$route.query.houseHoldNumber;
    this.allBody = {
      houseHoldNumber: this.$route.query.houseHoldNumber,
      phone: this.$route.query.phone,
      tenantId: this.$route.query.tenantId,
      mchName: this.$route.query.mchName,
      mchNumber: this.$route.query.mchNumber,
      address: this.$route.query.address,
      payType: this.$route.query.payType,
      devId: this.$route.query.devId,
      devType: this.$route.query.devType,
      productId: this.$route.query.productId,
      id: this.$route.query.id,
      actId: this.$route.query.actId,
      balance: this.$route.query.balance,
    };
    var date = new Date();
    for (let i = 0; i <= 5; i++) {
      let year = date.getFullYear() - i;
      this.columns.push(year);
    }
  },
  methods: {
    qisclick() {
      this.showprides = !this.showprides;
    },
    element() {
      this.$router.push({
        path: "/element",
        query: { houseHold: this.allBody.houseHoldNumber },
      });
    },
    balance() {
      this.$router.push({
        path: "/balance",
        query: {
          houseHold: this.allBody.houseHoldNumber,
          address: this.allBody.address,
          text: "",
          balance: "",
        },
      });
    },

    goJump1() {
      if (!this.price || 0 >= this.price) {
        console.log("请填写充值金额");
        this.$toast("请填写充值金额");
        this.$toast.fail("请填写充值金额");
        return;
      }
      // 先用路由里的手机号查询住户，弹窗确认绑定
      this.fetchBindListByRoutePhone();
    },

    async fetchBindListByRoutePhone() {
      const phone = (this.$route.query && this.$route.query.phone) ? String(this.$route.query.phone).trim() : '';
      this.bindQueryError = '';
      this.bindList = [];
      this.selectedBindIndex = -1;
      if (!/^1\d{10}$/.test(phone)) {
        this.bindQueryError = '路由手机号无效，无法查询用户';
        this.showBindPopup = true;
        return;
      }
      try {
        const res = await phoneHouse({ phone });
        const data = res && res.data ? res.data : [];
        this.bindList = Array.isArray(data) ? data : [data];
        if (this.bindList.length === 0) {
          this.bindQueryError = '未查询到该手机号的用户';
        }
      } catch (e) {
        this.bindQueryError = (e && e.msg) || '查询失败，请稍后再试';
      } finally {
        this.showBindPopup = true;
      }
    },

    async confirmBindAndPay() {
      if (this.selectedBindIndex < 0 || this.bindList.length === 0) {
        this.$toast.fail('请先选择要绑定的用户');
        return;
      }
      const selected = this.bindList[this.selectedBindIndex];
      // 二次确认：你确认要充值的用户地址是 xxx 吗？
      this.$dialog.confirm({
        title: '',
        message: `你确认要充值的用户地址是 ${selected.actName} 吗？`,
        showCancelButton: true
      }).then(async () => {
        this.binding = true;
        try {
          await bindHouse(selected);
          // 绑定成功后继续下单支付
          var data = {
            price: this.price,
            devId: this.allBody.devId,
            houseHoldNumber: this.allBody.houseHoldNumber,
            payType: this.payType,
            phone: (selected && selected.phone) || this.$route.query.phone || this.allBody.phone,
            devAddress: this.allBody.address,
            useType: 3,
            // 写死 充值账户余额
            type: 2,
            tenantId: this.allBody.tenantId,
            productId: this.allBody.productId,
            payment: this.allBody.payType,
          };
          if (this.content.productId == "dianbiao2022hyv1") {
            let price = parseFloat(this.price / this.ratePrice).toFixed(1) - 0;
            this.$set(data, "amount", price);
          }
          const payload = JSON.stringify(data);
          // 下单
          const reson = await orderAll(payload);
          console.log(reson, "orderAll_reson");
          this.showBindPopup = false;
          this.jsapPay(
              reson.data.orderNo,
              this.allBody.devType,
              reson.data.partnerCode,
              reson.data.storeId
          );
        } catch (error) {
          this.$toast.fail((error && error.msg) || '绑定或支付失败，请重试');
        } finally {
          this.binding = false;
        }
      }).catch(() => {
        // 用户取消
      });
    },

    // 跳转至支付页面
    jsapPay(orderNo, devType, partnerCode, storeId) {
      // console.log(orderNo+"|"+devType+"|"+partnerCode+"|"+storeId);
      let that = this;
      // console.log(window.__wxjs_environment,"111111111111");
      this.typ = window.__wxjs_environment;
      var isWxMini = window.__wxjs_environment === "miniprogram"; // 判断场景是否小程序
      // console.log(isWxMini);
      // console.log(this.$cookies.get("token"));
      const url =
        "/pages/extPay/index?orderNo=" +
        orderNo +
        "&token=" +
        this.$cookies.get("token") +
        "&devType=" +
        devType +
        "&partnerCode=" +
        partnerCode +
        "&storeId=" +
        storeId;
      if (isWxMini) {
        this.typ = "11跳转";
        wx.miniProgram.navigateTo({
          url: url,
          events: {
            paySuccess: function (payData) {
              that.$toast.success("支付成功!");
            },
          },
        });
      } else if (/MicroMessenger/i.test(navigator.userAgent)){
        // 微信公众号
        this.wxPay_h5(orderNo)
      }else {
        console.log(navigator.userAgent)
        this.$toast("请在微信端重新操作");
      }
    },

    wxPay_h5(orderNo) {
      wxPay(orderNo).then((reson) => {
        console.log("支付参数:", reson);
        let {subAppId, appId, nonceStr, paySign, signType, timeStamp} = reson.data;

        // console.log("支付参数:", payData);
        function onBridgeReady() {
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId": subAppId || appId,     //公众号ID，由商户传入
                "timeStamp": timeStamp,         //时间戳，自1970年以来的秒数
                "nonceStr": nonceStr, //随机串
                "package": reson.data.package,
                "signType": signType,         //微信签名方式：
                "paySign": paySign //微信签名
              },
              function (res) {
                console.log(res, "wxpay_res");
                // if(res.err_msg == "get_brand_wcpay_request:ok" ){
                //   // 使用以上方式判断前端返回,微信团队郑重提示：
                //   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                // }
                if (res.err_msg == "get_brand_wcpay_request:ok") { //支付成功点击完成跳转页面
                  WeixinJSBridge.invoke('closeWindow', {}, function (res) {
                  });
                }
                if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  this.$toast.success("您已取消支付");
                }
                if (res.err_msg == "get_brand_wcpay_request:fail") {
                  this.$toast.success("支付失败");
                }
              }
          );
        }

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      }).catch((error) => {
        console.error("获取支付参数失败:", error);
        this.$toast.fail("获取支付信息失败");
      });
    },

    backJump() {
      this.$destroy();
      jump.$emit("back");
      this.$router.go(-1);
    },
    hhh() {
      this.show = !this.show;
    },
    periodsonConfirm(value) {
      periods({
        houseHoldNumber: this.allBody.houseHoldNumber,
        billYear: this.year,
        billIssue: value,
      }).then((response) => {
        if (response.data.items[0].status == 0) {
          this.status = true;
        } else {
          this.status = false;
        }
        this.content = [];
        this.content = response.data.items[0];
      });
      this.qisclick();
    },
    onConfirm(value, index) {
      this.year = `${value}`;
      postpaid({
        houseHoldNumber: this.allBody.houseHoldNumber,
        billYear: value,
      }).then((response) => {
        this.content = [];
        if (response.data.items.length > 0) {
          let all = response.data.items.length;
          for (let i = 0; i < all; i++) {
            this.periods.push(response.data.items[i].billIssue);
          }
          if (response.data.items[0].status == 0) {
            this.status = true;
          } else {
            this.status = false;
          }
          this.content = response.data.items[0];
        }
      });
      this.hhh();
    },
    // 修复自定义金额显示问题
    backchange(much) {
      // 重置所有按钮颜色
      const resetColor = () => {
        this.colorone.backgroundColor = "#8e8e8e";
        this.colortwo.backgroundColor = "#8e8e8e";
        this.colorthree.backgroundColor = "#8e8e8e";
        this.colorzero.backgroundColor = "#8e8e8e";
      };

      resetColor();

      switch (much) {
        case 1:
          this.colorone.backgroundColor = "#2D86F6";
          this.price = 100;
          this.inputmonenone.display = "none";
          break;
        case 2:
          this.colortwo.backgroundColor = "#2D86F6";
          this.price = 200;
          this.inputmonenone.display = "none";
          break;
        case 3:
          this.colorthree.backgroundColor = "#2D86F6";
          this.price = 300;
          this.inputmonenone.display = "none";
          break;
        case 0:
          this.colorzero.backgroundColor = "#2D86F6";
          this.inputmonenone.display = "block";
          this.price = "";
          break;
      }
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "." + MM + "." + d;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.clear {
  clear: both;
}

.header {
  width: 100%;
  height: 192px;
  background-color: #295ad0;
}

.header h3 {
  letter-spacing: 2px;
  color: rgb(255, 255, 255);
  line-height: 120px;
  position: relative;
  margin-left: 20px;
}

.header h3 span {
  border-bottom: 3px solid #fff;
}

.content {
  width: 90%;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: -15px;
  padding-top: 5px;
}

.content_top {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
}

.bt {
  margin-bottom: 20px;
}

.bt img {
  width: 38px;
  height: 38px;
  float: left;
}

.bt span {
  line-height: 42px;
  margin-left: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

#topone {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottom {
  width: 90%;
  margin: 0 auto;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: 20px;
  background-color: #fff;
  padding: 20px 0;
}

.content_bottom {
  width: 80%;
  margin: 0 auto;
}

.center_bottom {
  margin-top: 20px;
}

.down {
  margin-bottom: 20px;
}

.down p {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #0f72dd;
}

.allin {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.allin .van-button {
  margin-bottom: 15px;
}

.foot {
  width: 90%;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin: 30px auto;
  background-color: #fff;
  padding: 20px 0;
}

.bot {
  width: 80%;
  margin: 0 auto;
}

.bot > p {
  font-size: 18px;
  font-weight: bold;
  color: #0f72dd;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.bot div {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.bot div img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.bot div div {
  margin-left: 60px;
  border-bottom: none;
  padding: 5px 0;
}

.bot div div span {
  font-size: 16px;
  font-weight: bold;
}

.bot div div p {
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 5px;
}

.bot div button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
